import { io, type Socket } from 'socket.io-client';
import { useAuthStore } from './auth';
import type { RealtimeEvent } from '@hooddesk/shared-types';

const REALTIME_URL = import.meta.env.VITE_REALTIME_URL ?? 'http://localhost:4100';

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (socket && socket.connected) return socket;
  const token = useAuthStore.getState().accessToken;

  socket = io(`${REALTIME_URL}/realtime`, {
    transports: ['websocket'],
    auth: { token: token ?? '' },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1_000
  });

  socket.on('connect_error', (err) => {
    // eslint-disable-next-line no-console
    console.warn('[socket] connect_error', err.message);
  });

  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}

export type RealtimeHandler = (e: RealtimeEvent) => void;

export function subscribe(eventName: RealtimeEvent['type'], handler: RealtimeHandler): () => void {
  const s = getSocket();
  const wrapped = (payload: Omit<RealtimeEvent, 'type'>): void => {
    handler({ type: eventName, ...payload } as RealtimeEvent);
  };
  s.on(eventName, wrapped);
  return () => s.off(eventName, wrapped);
}
